export default "__VITE_ASSET__Db0N7JoE__"